import { Add, DeleteOutline } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import { ACCENT } from "../../../../../../../layout/Header/components/CreateClientModal/shared";
import BulletListEditor from "../BulletListEditor";
import { textFieldSx } from "../styles";

function VariantsStep({
  variants,
  variantPointDrafts,
  setVariantPointDrafts,
  onAddVariant,
  onRemoveVariant,
  onUpdateVariantField,
  onAddVariantPoint,
  onRemoveVariantPoint,
}) {
  return (  
    <Stack spacing={2.5}>
      {variants.map((variant, index) => (
        <Box
          key={index}
          sx={{
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "12px",
            p: 2.5,
            background: "rgba(255,255,255,0.03)",
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 15 }}>Variant {index + 1}</Typography>
            <IconButton size="small" onClick={() => onRemoveVariant(index, variant.variantsId)} sx={{ color: "rgba(255,255,255,0.5)" }}>
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Stack>
          <Stack spacing={2}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField
                fullWidth
                label="Variant Title"
                value={variant?.variantsTitle || ""}
                onChange={(e) => onUpdateVariantField(index, "variantsTitle", e.target.value)}
                InputLabelProps={{ sx: { color: "rgba(255,255,255,0.5)" } }}
                sx={textFieldSx}
              />
              <TextField
                fullWidth
                label="Hook Name"
                value={variant?.hookName || ""}
                onChange={(e) => onUpdateVariantField(index, "hookName", e.target.value)}
                InputLabelProps={{ sx: { color: "rgba(255,255,255,0.5)" } }}
                sx={textFieldSx}
              />
            </Stack>
            <TextField
              fullWidth
              multiline
              minRows={2}
              label="Variant Description"
              value={variant?.variantsDescription || ""}
              onChange={(e) => onUpdateVariantField(index, "variantsDescription", e.target.value)}
              InputLabelProps={{ sx: { color: "rgba(255,255,255,0.5)" } }}
              sx={textFieldSx}
            />
            <Box>
              <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1 }}>Variant Points</Typography>
              <BulletListEditor
                items={variant?.variantsPoints || []}
                draft={variantPointDrafts[index] || ""}
                setDraft={(value) =>
                  setVariantPointDrafts((prev) => ({ ...prev, [index]: value }))
                }
                onAdd={() => onAddVariantPoint(index)}
                onRemove={(pointIndex) => onRemoveVariantPoint(index, pointIndex)}
                placeholder="e.g. Product clarity > story arc"
              />
            </Box>
          </Stack>
        </Box>
      ))}
      <Button
        onClick={onAddVariant}
        startIcon={<Add />}
        sx={{
          alignSelf: "flex-start",
          color: ACCENT,
          border: `1px dashed ${ACCENT}`,
          textTransform: "none",
          borderRadius: "10px",
          px: 2.5,
          py: 1,
          "&:hover": { background: "rgba(219, 165, 41, 0.08)" },
        }}
      >
        Add Variant
      </Button>
    </Stack>
  );
}

export default VariantsStep;
